import { render } from "./InfiniteScrollSelect.vue?vue&type=template&id=5c5f23a2&scoped=true"
import script from "./InfiniteScrollSelect.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollSelect.vue?vue&type=script&lang=js"

import "./InfiniteScrollSelect.vue?vue&type=style&index=0&id=5c5f23a2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5f23a2"]])

export default __exports__